"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceOpacity = exports.getRgba = void 0;
/**
 * Reduces the opacity level to the specified percentage
 * @param color - Hexademical formatted string
 * @param percentage - Decimal percentage to reduce the color to
 */
var reduceOpacity = (color, percentage) => {
  // Convert to base 16 Hex in format 0.00..00000
  var hexRaw = percentage.toString(16);
  // Extract rounded part
  var parsed = hexRaw.slice(2, 4);
  var res = color + parsed;
  return res;
};
exports.reduceOpacity = reduceOpacity;
var RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;
var hex2RGB = str => {
  var [, short, long] = String(str).match(RGB_HEX) || [];
  if (long) {
    var value = Number.parseInt(long, 16);
    return [value >> 16, value >> 8 & 0xff, value & 0xff];
  } else if (short) {
    return Array.from(short, s => Number.parseInt(s, 16)).map(n => n << 4 | n);
  }
};

/**
 * Retrieves an RGBA color string from a hex value and transparency
 * level
 */
var getRgba = (hex, transparency) => {
  // If parameters are not defined return original hex
  if (!hex || !transparency) {
    return hex;
  }
  var [r, g, b] = hex2RGB(hex);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(transparency, ")");
};
exports.getRgba = getRgba;